__turbopack_context__.v({
  "className": "IngCSq_className",
});
